/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, NlpIntegrationGetLiveTopicsStationSettingsPathParams, NlpIntegrationGetLiveTopicsStationSettings401, NlpIntegrationGetLiveTopicsStationSettings403 } from "../models/NlpIntegrationGetLiveTopicsStationSettings";

export function getNlpIntegrationGetLiveTopicsStationSettingsUrl(entityId: NlpIntegrationGetLiveTopicsStationSettingsPathParams["entityId"]) {
  const res = { method: 'GET', url: `/nlp-integration/v1/live-topics/station-settings/${entityId}` as const }
  return res
}

/**
 * @description Every setting is resolved to its effective value, taking the station's own value when present, then the inherited value, then the built-in default. Only settings available to API clients are included.
 * @summary Get the effective settings of a station
 * {@link /nlp-integration/v1/live-topics/station-settings/:entityId}
 */
export async function nlpIntegrationGetLiveTopicsStationSettings(entityId: NlpIntegrationGetLiveTopicsStationSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, ResponseErrorConfig<NlpIntegrationGetLiveTopicsStationSettings401 | NlpIntegrationGetLiveTopicsStationSettings403>, unknown>({ method : "GET", url : getNlpIntegrationGetLiveTopicsStationSettingsUrl(entityId).url.toString(), ... requestConfig })
  return res.data
}